module.exports = __webpack_public_path__ + "static/web-painting-8-24d5cc8a9d5220a20ce612ee28d37b56.jpg";